import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { set_is_mobile_sidebar } from "../core/data/redux/action";
import { Outlet } from "react-router-dom";
import Header from "./common/header";
import Progress from "./common/progressbar";
import Footer from "./common/footer";

const Feature = () => {
  const mobileSidebar = useSelector((state: any) => state.rootReducer.mobileSidebar);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(set_is_mobile_sidebar(false));
  }, [ dispatch]);

  return (
    <>
    <div className={`main-wrapper ${mobileSidebar ? "menu-opened " : ""}`}>
    <Header />
    <Outlet />
    <Progress />
    <Footer />
    </div>
  </>
   
  );
};

export default Feature;
